import { instance } from './axios';
import type { AxiosResponse } from './axios';

const axios = instance;

export { axios };
export type { AxiosResponse };
